import React, { useState, useEffect } from 'react';

const PartnerEditModal = ({ partner, isOpen, onClose, onSave, availableImages, onUpload }) => {
    const [formData, setFormData] = useState({
        name: '',
        website: '',
        image: '',
        preferred: false
    });
    const [isUploading, setIsUploading] = useState(false);

    useEffect(() => {
        if (partner) {
            setFormData({
                name: partner.name || '',
                website: partner.website || '',
                image: partner.image || '',
                preferred: partner.preferred || false
            });
        } else {
            setFormData({
                name: '',
                website: '',
                image: '',
                preferred: false
            });
        }
    }, [partner]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({ ...partner, ...formData });
    };

    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        setIsUploading(true);
        try {
            const uploadedPaths = await onUpload(files);
            if (uploadedPaths && uploadedPaths.length > 0) {
                setFormData(prev => ({ ...prev, image: uploadedPaths[0] }));
            }
        } catch (error) {
            console.error("Upload failed in modal:", error);
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md">
                <h2 className="text-2xl font-bold mb-4">{partner ? 'Edit Partner' : 'Add New Partner'}</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                        <input
                            type="text"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Website URL <span className="text-gray-400 font-normal">(Optional)</span></label>
                        <input
                            type="url"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                            value={formData.website}
                            onChange={(e) => setFormData({ ...formData, website: e.target.value })}
                            placeholder="https://example.com"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                className="w-4 h-4 text-black border-gray-300 rounded focus:ring-black"
                                checked={formData.preferred}
                                onChange={(e) => setFormData({ ...formData, preferred: e.target.checked })}
                            />
                            <span className="text-sm font-medium text-gray-700">Preferred Partner (Show at top)</span>
                        </label>
                    </div>
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Image</label>
                        <div className="flex gap-2 mb-2">
                            <select
                                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                                value={formData.image}
                                onChange={(e) => setFormData({ ...formData, image: e.target.value })}
                                required
                            >
                                <option value="">Select an image</option>
                                {availableImages.map((img) => (
                                    <option key={img} value={img}>
                                        {img}
                                    </option>
                                ))}
                            </select>
                            <label className={`px-4 py-2 bg-gray-200 text-gray-700 rounded-md cursor-pointer hover:bg-gray-300 transition-colors ${isUploading ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    disabled={isUploading}
                                    className="hidden"
                                />
                                {isUploading ? '...' : 'Upload'}
                            </label>
                        </div>

                        {formData.image && (
                            <div className="mt-2">
                                <p className="text-xs text-gray-500 mb-1">Preview:</p>
                                <img
                                    src={`https://storage.googleapis.com/wacofirefightersbenefit/${formData.image}`}
                                    alt="Preview"
                                    className="h-20 object-contain rounded border border-gray-200"
                                />
                            </div>
                        )}
                    </div>
                    <div className="flex justify-end gap-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800 transition-colors"
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PartnerEditModal;
